import React, { PropsWithChildren, ReactNode } from "react";

interface IErrorBoundary extends PropsWithChildren {
  fallback?: ReactNode;
}

class ErrorBoundary extends React.Component<IErrorBoundary> {
  state = { hasError: false };

  static getDerivedStateFromError(err: any) {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    console.error(error);
    console.error(errorInfo);
  }

  render(): React.ReactNode {
    if (this.state.hasError) {
      return this.props.fallback;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
